<template lang="pug">
  div
    el-card.card-container(shadow="hover", style="margin: 15px 0 20px 0;")
      app-opcoes-header-analise.right(
        v-if="opcoesAcoes",
        :idProcesso="idProcesso",
        :protocolo="numeroProtocolo"
        :statusProcesso="statusProcesso"
        :numeroProcesso="numeroProcesso",
        :tipoProcesso="tipoCodigoProcesso",
        :btnNotificarInteressado="false",
        :btnRetificacao="false",
        :btnSolicitarInformacao="false"
        )
      h4 Nome do Interessado:
       span.span-style  {{ nomeInteressado ? nomeInteressado : ' - '  }}
      h4 CPF/CNPJ do Interessado:
        span.span-style  {{ cpfCnpjInteressado ? cpfCnpjInteressado : ' - ' }}
      h4 Setor:
        span.span-style  {{ setorProcesso ? setorProcesso : ' - ' }}
      h4 Status:
        span.span-style  {{ statusProcesso ? statusProcesso : ' - ' }}
      h4(v-if="usuario") Usuario:
        span.span-style {{ usuario.pessoa.nomeRazaoSocial ? usuario.pessoa.nomeRazaoSocial : ' - '}}
</template>

<script>
import AppOpcoesHeaderAnalise from '../../analise/components/modal/AppOpcoesHeaderAnalise.vue'
export default {
  components: {
    AppOpcoesHeaderAnalise
  },
  props: {
    idProcesso: {
      require: true
    },
    nomeInteressado: {
      require: true
    },
    statusProcesso: {
      require: true
    },
    numeroProcesso: {
      require: true
    },
    cpfCnpjInteressado: {
      require: true
    },
    setorProcesso: {
      require: true
    },
    opcoesAcoes: {
      require: false,
      default: false
    },
    tipoCodigoProcesso: {
      require: false
    },
    numeroProtocolo: {
      require: false
    },
    usuario: {
      require: false
    }
  }
}
</script>

<style scoped>

.span-style {
  font-weight: normal;
  margin-left: 3px;
}
.right {
  display: flex;
  justify-content: right;
}
</style>



// WEBPACK FOOTER //
// src/screens/manutencao/components/CardProcesso.vue